<template>
  <div>
    <vs-select  class="w-full mb-8" :label="'契约只在' + activeGroup.name + '及下级用户组生效'" v-model="dataLocal.group">
      <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in groupList" />
    </vs-select>
    <vs-input class="w-full mb-4" v-model="dataLocal.activeBet" :label-placeholder="'每小时投注达到' + dataLocal.activeBet + '算活跃人数'" />

    <vs-divider />

    <vs-table stripe :data="dataLocal.list" noDataText="暂无规则">
      <template slot="header">
        <div class="w-full mb-2 flex items-center justify-between">
          <h4>规则</h4>
          <vs-button color="success" size="small" @click="add">添加</vs-button>
        </div>
      </template>
      <template slot="thead">
        <vs-th width="80">用户组</vs-th>
        <vs-th width="80">流水</vs-th>
        <vs-th width="80">亏损</vs-th>
        <vs-th width="80">有效人数</vs-th>
        <vs-th width="80">返水(%)</vs-th>
        <vs-th width="60">
          <div class="text-center w-full">操作</div>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(item, index) in dataLocal.list" >
          <vs-td :data="item.group">
            <vs-select class="w-full" v-model="item.group">
              <vs-select-item :key="index2" :value="item2.id" :text="item2.name" v-for="(item2, index2) in groupList" />
            </vs-select>
          </vs-td>
          <vs-td :data="item.total">
            <vs-input class="w-full" v-model="dataLocal.list[index].total" />
          </vs-td>
          <vs-td :data="item.lose">
            <vs-input class="w-full" v-model="dataLocal.list[index].lose" />
          </vs-td>
          <vs-td :data="item.count">
            <vs-input class="w-full" v-model="dataLocal.list[index].count" />
          </vs-td>
          <vs-td :data="item.percent">
            <vs-input class="w-full" v-model="dataLocal.list[index].percent" />
          </vs-td>
          <vs-td>
            <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="del" :data-index="index">删除</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    },
    groupList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    del(e) {
      this.dataLocal.list.splice(e.currentTarget.dataset.index, 1)
    },
    add() {
      this.dataLocal.list.push({})
    },
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  },
  computed: {
    activeGroup() {
      for (let i = 0; i < this.groupList.length; i++) {
        if (this.groupList[i].id == this.dataLocal.group) return this.groupList[i]
      }
      return {}
    }
  },
}
</script>
